module.exports = __webpack_public_path__ + "img/tech.1aabd752.svg";